import moment from "moment";
import {api_format} from "../Helpers";

export const CreatedAtColumnFormatter = (cellContent, row) =>  row.created_at ? moment(row.created_at,api_format).format('L') : " - "